import { Modal } from "@mijadesign/web";
import type { ModalProps } from "antd";

export type ModalWrapperProps = ModalProps;

function ModalWrapper(props: ModalWrapperProps) {
  const {
    title,
    open = true,
    width = 520,
    children,
    footer,
    ...restProps
  } = props;

  return (
    <Modal {...restProps} title={title} open={open} width={width} footer={footer}>
      {children}
    </Modal>
  );
}

export default ModalWrapper;
